import fbx_file_foot from '@/assets/3d/models/foot.fbx?url';
import * as THREE from 'three';
import { ConstantsOpenPose } from '../constants_open_pose';
import { EOpenPoseBodyPartMask } from '../enums/e_open_pose_body_part_mask';
import { find_object_item } from '../open_pose_body/open_pose_body_utils';
import { fbx_file_loader } from './fbx_file_loader';

export async function load_foot_from_file() {
  const out = await fbx_file_loader(fbx_file_foot);

  const mesh = find_object_item<THREE.SkinnedMesh>(out, ConstantsOpenPose.MODEL_INFO_FOOT.mesh_name)!;
  mesh.material = new THREE.MeshPhongMaterial();

  for (const object of mesh.skeleton.bones) {
    const point = new THREE.Mesh(
      new THREE.SphereGeometry(0.1),
      new THREE.MeshBasicMaterial({
        color: ConstantsOpenPose.FOOT_COLOR,
        depthTest: false,
        transparent: true,
      }),
    );

    point.name = ConstantsOpenPose.INTERSECT_TARGET_POINT_NAME;
    point.translateX(-0.3);
    object.add(point);
  }

  const geometry = new THREE.CylinderGeometry(0.35, 0.35, 0.2, 32);
  const material = new THREE.MeshBasicMaterial({ color: ConstantsOpenPose.FOOT_MASK_COLOR });

  const mask = new THREE.Mesh(geometry, material);

  mask.scale.setX(0.7);
  mask.name = EOpenPoseBodyPartMask.FOOT;
  mask.visible = false;

  mesh.skeleton.bones[0].add(mask);

  ConstantsOpenPose.OPEN_POSE_PART_FROM_FILE_FOOT = out;
}
